"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.softBoxShadow = void 0;

var softBoxShadow = function softBoxShadow(color) {
  return "\n        -webkit-box-shadow: 0px 6px 10px -5px ".concat(color ? color : "rgba(0,0,0,0.25)", "; \n        box-shadow: 0px 6px 10px -5px ").concat(color ? color : "rgba(0,0,0,0.25)", ";\n    ");
};

exports.softBoxShadow = softBoxShadow;